/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import Text from './Text';

import styles from '../../../styles/partials/film-info-section.scss';

const propTypes = {
    label: PropTypes.shape({
        id: PropTypes.string,
        defaultMessage: PropTypes.string,
    }).isRequired,
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const FilmInfoSection = ({ label, text, className }) => (
    <div
        className={classNames({
            [styles.container]: true,
            [className]: className !== null,
        })}
    >
        <h4 className={styles.title}>
            <FormattedMessage {...label} />
        </h4>
        <div className={styles.text}>
            <Text>{text}</Text>
        </div>
    </div>
);

FilmInfoSection.propTypes = propTypes;
FilmInfoSection.defaultProps = defaultProps;

export default FilmInfoSection;



// WEBPACK FOOTER //
// ./js/components/partials/FilmInfoSection.jsx